import * as React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Backdrop,
  Button,
  CircularProgress,
  Box,
  TextField,
  Pagination,
  FormControl,
  Autocomplete,
  Tooltip,
  IconButton,
  Switch,
  Stack,
  Typography,
} from '@mui/material';

import moment from 'moment';
import { useState } from 'react';
import HttpService from '../../hooks/Https-services';
import PAGE_ROUTES, {
  API_ROUTES,
  dateFormat,
  timeFormat,
} from '../../utils/constant';
import { useNavigate } from 'react-router';
import Iconify from '../../components/iconify';
import { GlobalSearchContext } from '../../context/GlobalSearchContext';

function BroadcastNotification() {
  const [tableData, setTableData] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(10);
  const itemsPerPage = 10;
  const navigate = useNavigate();
  const [selectedDuration, setSelectedDuration] = useState<number | null>(null);
  const { fetchBroadcastNotifications }: any =
    React.useContext(GlobalSearchContext);

  const handleChange = (event: React.SyntheticEvent, newValue: any) => {
    setSelectedDuration(newValue ? newValue.value : null);
  };
  const fetchNotificationList = React.useCallback(async () => {
    const query: any = {
      page: currentPage,
      limit: itemsPerPage,
      notification_type: 7,
    };

    try {
      setLoading(true);
      const response = await HttpService.get(
        API_ROUTES.notificationTableList +
          `?${new URLSearchParams(query).toString()}`
      );
      setTableData(response.data.data.list || []);
      setTotalPages(response.data.data.totalPages);
    } catch (error: any) {
      console.error('Error fetching user list:', error);
    } finally {
      setLoading(false);
    }
  }, [currentPage, selectedDuration]);

  React.useEffect(() => {
    fetchNotificationList();
  }, [fetchNotificationList]);

  const clearFilter = () => {
    setSelectedDuration(null);
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page); // Update the current page
  };

  const addBroadcastNotification = () => {
    navigate(PAGE_ROUTES.ADDBROADCASTNOTIFICATION);
  };
  const handleNavigateToUser = (id: any) => {
    navigate(`/broadcast-notification-users/${id}`);
  };
  const handleActiveInactiveStatus = async (id: string, status: number) => {
    try {
      console.log('test', status);
      setLoading(true);
      const updatedStatus = status == 2 ? 1 : 2;
      console.log('update', updatedStatus);
      const data = { notificationId: id, status: updatedStatus };
      await HttpService.patch(`${API_ROUTES.markAsRead}`, data);
      fetchBroadcastNotifications();
      fetchNotificationList();
    } catch (error) {
      console.error('Error updating status:', error);
    } finally {
      setLoading(false);
    }
  };

  function Row(props: { row: any }) {
    const { row } = props;

    return (
      <React.Fragment>
        <TableRow>
          <TableCell sx={{ '&:hover': { color: 'orange', cursor: 'pointer' } }}>
            {row?.message}
          </TableCell>
          <TableCell sx={{ '&:hover': { color: 'orange', cursor: 'pointer' } }}>
            {row?.user?.name}
          </TableCell>
          <TableCell sx={{ '&:hover': { color: 'orange', cursor: 'pointer' } }}>
            {row?.createdAt ? (
              <Stack direction={'column'}>
                <Typography variant="body2">
                  {moment(row?.createdAt).format(`${dateFormat}`)}
                </Typography>
                <Typography variant="body2">
                  {moment(row?.createdAt).format(`${timeFormat}`)}
                </Typography>
              </Stack>
            ) : (
              '-'
            )}
          </TableCell>
          {/* <TableCell sx={{ '&:hover': { color: 'orange', cursor: 'pointer' } }}>
            {row?.readAt
              ? moment(row?.readAt).format(`${dateFormat} hh:mm a`)
              : '-'}
          </TableCell>
          <TableCell sx={{ '&:hover': { color: 'orange', cursor: 'pointer' } }}>
            {row?.status}
          </TableCell> */}
          <TableCell
            align="left"
            sx={{ margin: '0', padding: '0', whiteSpace: 'nowrap' }}
          >
            <Tooltip title="User Details" placement="top" arrow>
              <IconButton
                onClick={() => {
                  handleNavigateToUser(row.id); // Set the current user for quick edit
                }}
              >
                <Iconify icon="flowbite:eye-solid" />
              </IconButton>
            </Tooltip>
            <Tooltip
              title={row.ActiveStatus === 1 ? 'Make In Active' : `Make Active`}
              placement="top"
              arrow
            >
              <Switch
                checked={row.ActiveStatus === 1}
                onChange={() =>
                  handleActiveInactiveStatus(row.id, row.ActiveStatus)
                }
                color="primary"
              />
            </Tooltip>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <>
      {' '}
      <Box
        sx={{
          display: 'flex',
          padding: '20px 0',
          alignItems: 'center',
          //   justifyContent: 'space-between',
          justifyContent: 'flex-end',
        }}
      >
        <Box sx={{ display: 'flex', gap: 2 }}>
          {' '}
          <Box
            sx={{
              display: 'flex',

              flexDirection: { md: 'column', lg: 'row' },
              gap: 1,
            }}
          >
            <Box>
              {' '}
              <Button
                variant="contained"
                onClick={addBroadcastNotification}
                sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
              >
                Add Broadcast Notification
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Massage</TableCell>
              <TableCell align="left">User Name</TableCell>
              <TableCell align="left">Created At</TableCell>
              {/* <TableCell align="left">Read At</TableCell>
              <TableCell align="left">Status</TableCell> */}
              <TableCell align="left">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(tableData || []).map((data: any) => (
              <Row key={data.id} row={data} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {/* Pagination Component */}
      <Box display="flex" justifyContent="center" my={2}>
        <Pagination
          count={totalPages} // Total number of pages
          page={currentPage} // Current page
          onChange={handlePageChange} // Handle page change
          color="primary"
        />
      </Box>
      {/* Backdrop with CircularProgress for loader */}
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default BroadcastNotification;
